export default {"src":"/_next/static/media/sub-menu-logo.615a5172.svg","height":20,"width":56,"blurWidth":0,"blurHeight":0};